import * as React from 'react';
import { Divider, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useIntl } from 'react-intl';

import { CalendarPeriod } from 'components/DatePicker/utils/constants';
import Helmet from 'react-helmet';
import TimeFilter from 'pages/Report/components/TimeFilter';
import { StatusMetric } from 'redux/ducks/dashboard';
import TipOfTheWeekCard from 'pages/Dashboard/TipOfTheWeekCard';
import EsmileyClubCard from 'pages/Dashboard/EsmileyClubCard';
import DashboardMetricCard from 'pages/Dashboard/DashboardMetricCard';
import { TimeRange } from 'redux/ducks/reportFilter';
import { VacationBar } from 'pages/Dashboard/VacationBar';

export interface DashboardProps {
  metrics: StatusMetric[];
  vacation: TimeRange[];
  isLoading: boolean;
  isMenuOpen: boolean;
}

type OwnProps = DashboardProps;

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('xl')]: {
      maxWidth: '1200px'
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: '1600px'
    },
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: theme.spacing(3)
  },
  header: {
    margin: theme.spacing(1.5, 0, 3),
    '&:after': {
      content: '""',
      flex: 1
    }
  },
  headerFilterRow: {
    [theme.breakpoints.down('md')]: {
      order: 1
    }
  },
  headerFilter: {
    maxWidth: '320px'
  },
  headerTitleRow: {
    [theme.breakpoints.down('md')]: {
      order: 0
    }
  },
  headerTitle: {},
  cardContainer: {},
  vacationRow: {
    marginBottom: theme.spacing(3)
  },
  footerSection: {},
  divider: {
    height: '2px',
    width: '90%',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  }
}));

const Dashboard: React.FunctionComponent<OwnProps> = (props) => {
  const classes = useStyles();
  const intl = useIntl();
  const { metrics, vacation, isLoading, isMenuOpen } = props;
  return (
    <Grid container justify='center' className={classes.root}>
      <Helmet title={intl.formatMessage({ id: 'dashboard.headline' })} />
      <Grid container justify='space-between' className={classes.header}>
        <Grid item xs={12} sm={6} className={classes.headerFilterRow}>
          <TimeFilter
            skipFilterReload
            updateCache
            periods={[
              CalendarPeriod.week,
              CalendarPeriod.month,
              CalendarPeriod.quarter,
              CalendarPeriod.year
            ]}
            className={classes.headerFilter}
          />
        </Grid>
        <Grid item xs={12} sm={6} className={classes.headerTitleRow}>
          <Typography variant='h1' className={classes.headerTitle}>
            {intl.formatMessage({ id: 'dashboard.headline' })}
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={12} className={classes.vacationRow}>
        <VacationBar vacation={vacation} />
      </Grid>
      <Grid item container spacing={3} className={classes.cardContainer}>
        {metrics.map((metric, i) => (
          <Grid key={`dashboard_card_${i}`} item xs={12} md={6} xl={4}>
            <DashboardMetricCard key={metric.id} metric={metric} isLoading={isLoading} />
          </Grid>
        ))}
      </Grid>
      <Divider className={classes.divider} />
      <Grid container spacing={3} className={classes.footerSection}>
        <Grid item xs={12} md={isMenuOpen ? 12 : 6} lg={6}>
          <TipOfTheWeekCard />
        </Grid>
        <Grid item xs={12} md={isMenuOpen ? 12 : 6} lg={6}>
          <EsmileyClubCard />
        </Grid>
      </Grid>
    </Grid>
  );
};
export default Dashboard;
